import { parseQueryParam } from 'src/utils/parseQueryParam';
import { isArrayOfStrings } from 'src/utils/isArrayOfStrings';
import { fromEntries } from 'src/utils/fromEntries';
import { Filter, FilterConfig } from 'src/utils/composeFilter.ts';

export function getFilterValuesFromUrl(searchPart: URLSearchParams, config: FilterConfig): Filter {
    const filterValues = config.map<[string, string[]]>((item) => {
        const [name] = item;
        return [name, parseQueryParam(searchPart.get(name))];
    })
        .filter(([, value]) => {
            if (isArrayOfStrings(value)) {
                return value.length > 0;
            }
            return false;
        });
    return fromEntries<string[]>(filterValues);
}
